export default {
  path: '/roles-resource',
  name: 'r_roles-resource',
  meta: {
    middlewares: {
      auth: null,
      permission: 'RESOURCES_ROLES',
    },
  },
  props: {
    containerType: 'RESOURCE',
    backLinkName: 'r_roles-resource',
  },
  component: () => import('../../components/roles/Roles'),
  children: [
    {
      path: 'add',
      name: 'r_add-resource-role',
      meta: {
        middlewares: {
          auth: null,
          permission: 'RESOURCES_ROLES',
        },
      },
      props: { backLinkName: 'r_roles-resource', containerType: 'RESOURCE' },
      component: () => import('../../components/roles/AddRole'),
    },
    {
      path: 'edit',
      name: 'r_edit-resource-role',
      meta: {
        middlewares: {
          auth: null,
          permission: 'RESOURCES_ROLES',
        },
      },
      props: { backLinkName: 'r_roles-resource', containerType: 'RESOURCE' },
      component: () => import('../../components/roles/EditRole'),
      children: [
        {
          path: 'permissions',
          name: 'r_edit-resource-add-permissions-to-role',
          meta: {
            middlewares: {
              auth: null,
              permission: 'RESOURCES_ROLES',
            },
          },
          props: {
            backLinkName: 'r_edit-resource-role',
            containerType: 'RESOURCE',
          },
          component: () => import('../../components/roles/RolesAddPermissions'),
        },
      ],
    },
  ],
};
